export const CONSTANTS = {
  EMAIL: 'email',
  PERMISSIONS: 'permissions',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN: 'token',
  USER: 'user',
  ARCGIS_TOKEN: 'arcgis',
  TYC:'tyc'
};
